import TraCuu from "./stores/TraCuu";
import ManHinh from "./stores/ManHinh";
export default {
    modules: {
        TraCuu,
        ManHinh,
    },
};
